<template>
  <section class="myCenterCommon__userContent__2fHEF route-fade-enter-done">
    <div class="myCenterCommon__users_layout__title__3CoQ0"><h3>红包记录</h3></div>
    <div class="myCenterCommon__users_layout__params__2DfEC">
      <div class="myCenterCommon__check_wrap__3bM7H">
        <button @click="$parent.goNav('/userredpacket')"  class="index__Button__It0J4 index__Button3__1Pn-Q" style="width: 113px; height: 40px; position: absolute; left: 120px; top: -60px">领取红包</button>
        <div style="width: 200px; line-height: 40px; height: 40px; position: absolute; left: 300px; top: -60px">
          剩余领取次数：<span style="font-weight: bold; color: red">{{ userredpacket.sendnums }}</span>
        </div>
        <div style="width: 200px; line-height: 40px; height: 40px; position: absolute; left: 500px; top: -60px">
          累计领取次数：<span style="font-weight: bold; color: red">{{ userredpacket.acquirednum }}</span>
        </div>
      </div>
    </div>
    <el-table :data="redpacketList" style="width: 100%">
      <el-table-column type="index" label="序号"> </el-table-column>
      <el-table-column prop="money" label="充值金额"> </el-table-column>
      <el-table-column prop="redpacketmoney" label="红包金额"> </el-table-column>
      <el-table-column prop="created_at" label="充值时间"> </el-table-column>
      <el-table-column prop="usetime" label="领取时间"> </el-table-column>
    </el-table>
    <el-pagination v-if="redpacketShowData.total" style="margin: 20px 0 0px 120px" @current-change="getredpacket" :current-page.sync="page" :page-size="10" layout="prev, pager, next" :total="redpacketShowData.total"></el-pagination>
  </section>
</template>
<script>
export default {
  name: 'welfare',
  data() {
    return {
      redpacketList: [],
      page: 1,
      redpacketShowData: {},
      userredpacket: {},
    };
  },
  created() {
    let that = this;
    that.getuserredpacket();
  },
  methods: {
    getwelfare() {
      let that = this;
      if (that.userredpacket.sendnums < 1) {
        that.$parent.showTost(0, '您的剩余次数不足！');

        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/douserredpacket', {})
        .then(res => {
          console.log(res);

          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
          that.getuserredpacket();
        })
        .catch(() => {
          that.$parent.showTost(0, '服务器异常，请稍后再试');
          that.$parent.hideLoading();
        });
    },

    getuserredpacket() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/userredpacket', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.userredpacket = res.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
@import '/static/css/Transfer_81ba8019.f1b60e17.css';

</style>



// WEBPACK FOOTER //
// src/components/mine/welfare.vue